import { render, staticRenderFns } from "./adminTop.vue?vue&type=template&id=31fc85bb&scoped=true&"
import script from "./adminTop.vue?vue&type=script&lang=js&"
export * from "./adminTop.vue?vue&type=script&lang=js&"
import style0 from "./adminTop.vue?vue&type=style&index=0&id=31fc85bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc85bb",
  null
  
)

export default component.exports